import React, { useState, useEffect, useRef } from 'react';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navbarRef = useRef(null);
  useEffect(() => {
    // Função para fechar o menu ao clicar fora da barra
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    // Adiciona o event listener quando o menu está aberto
    if (isMenuOpen) {
      document.addEventListener('click', handleClickOutside);
    }
    // Remove o event listener quando o componente é desmontado
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMenuOpen]);
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    section.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false); // Close menu after clicking on a section link
  };

  return (
    <nav className='absolute w-full flex justify-between p-4 items-center sticky top-0 backdrop-blur-lg hover:bg-custom-blue text-white font-bold text-2xl z-20' ref={navbarRef}>
      <h1 className='text-white font-bold text-2xl z-20 '>ArchIA</h1>

      {/* Mobile Menu */}
      <div className="md:hidden">
        <button 
          className="text-white font-bold text-2xl z-20" 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </button>
      </div>

      {/* Desktop Menu */}
      <div className="hidden md:flex justify-center space-x-6">


        <h1 className='text-white font-bold text-1xl z-20 cursor-pointer' onClick={() => scrollToSection('hero-section')}>Home</h1>
        <h1 className='text-white font-bold text-1xl z-20 cursor-pointer' onClick={() => scrollToSection('offers-section')}>Soluções</h1>
        <h1 className='text-white font-bold text-1xl z-20 cursor-pointer' onClick={() => scrollToSection('image-slider-section')}>Amostras</h1>
        <h1 className='text-white font-bold text-1xl z-20 cursor-pointer' onClick={() => scrollToSection('faq-section')}>FAQ</h1>
      </div>
      <div className="hidden md:flex justify-right space-x-4">
        <h1 className='text-white font-bold text-2xl z-20'>Planos</h1>
        <h1 className='text-white font-bold text-2xl z-20'>Login</h1>
      </div>

      {/* Mobile Menu Content */}
      {isMenuOpen && (
        <div className="md:hidden flex flex-col justify-center items-center space-y-2">
          <h1 className='text-white font-bold text-lg z-20 cursor-pointer' onClick={() => scrollToSection('hero-section')}>Home</h1>
          <h1 className='text-white font-bold text-lg z-20 cursor-pointer' onClick={() => scrollToSection('offers-section')}>Soluções</h1>
          <h1 className='text-white font-bold text-lg z-20 cursor-pointer' onClick={() => scrollToSection('image-slider-section')}>Amostras</h1>
          <h1 className='text-white font-bold text-lg z-20 cursor-pointer' onClick={() => scrollToSection('faq-section')}>FAQ</h1>
          <h1 className='text-white font-bold text-lg z-20'>Planos</h1>
          <h1 className='text-white font-bold text-lg z-20'>Login</h1>
        </div>
      )}
    </nav>
  );
};

    
          
    
    
  
export default Navbar;